export const invoice = {
  enter_note: "Saisir une note...",
  enter_payment_terms: "Saisir les conditions de paiement...",
  enter_execution_conditions: "Saisir les conditions d’exécution...",
  invoice_list: "Liste des factures",
  title: "Factures",
  search_placeholder: "Rechercher",
  all: "Toutes",
  draft: "Brouillons",
  finalized: "À valider",
  paid: "Validées",
  to_pay: "Publiées",
  client_name: "Client",
  empty_title: "Créez une facture",
  email: "Email",
  empty_description:
    "Créez et envoyez vos factures à vos clients en toute simplicité",
  select_client_first: "Sélectionnez d'abord une entreprise",
  choose_client: "Choisissez un client",
  create_button: "Créer une facture",
  company_name: "Nom de l'entreprise*",
  new_invoice: "Nouvelle facture de vente",
  recipient: "Destinataire*",
  new_client: "Nouveau client",
  choose_company: "Sélectionnez une entreprise",
  new_companies: "Nouvelle société",
  informations: "Informations",
  currency: "Devise (requis)",
  checkboxTVA: "TVA non applicable",
  seller_name: "Nom du vendeur",
  seller_email: "Email du vendeur",
  seller_address: "Adresse du vendeur",
  invoice_number: "N° de facture",
  command_number: "N° de commande",
  invoice_date: "Date de facturation*",
  due_date_invoice: "Date d'échéance*",
  type_invoice: "Type de facture",
  articles: "Articles",
  type: "Type",
  quantity: "Quantité",
  price_ht: "Prix unitaire (HT)",
  total_ht: "Montant HT",
  tva: "TVA",
  debours: "Débours",
  reduction: "Remise",
  add_debours: "+ Ajouter un débours",
  regulation: "Règlement",
  conditions: "Conditions de règlement",
  regulation_mode: "Mode de règlement",
  late_interests: "Intérêts de retard",
  no_late_interests: "Pas d’intérêts de retard",
  bank_account: "Compte bancaire (RIB)",
  default_conditions: "45 jours fin de mois",
  default_regulation_mode: "Virement bancaire",
  client: "Client",
  client_name_label: "Nom du client",
  client_email: "Email du client",
  client_address: "Adresse du client",
  amount: "Montant",
  due_date: "Date d'échéance",
  status: "Statut",
  submit: "Enregistrer la facture",
  document_text: "Textes affichés sur le document",
  keywords: "Mots clés",
  choose_keywords: "Ajouter/Sélectionner des mots clés",
  notes: "Notes",
  payment_solution: "Solution de paiement rapide",
  add_line: "+ Ajouter une ligne",
  end_date: "Au",
  start_date: "Date de facturation",

  // UI actions/buttons
  cancel: "Annuler",
  preview: "Prévisualiser",
  save_draft: "Sauvegarder brouillon",
  creating: "Création...",
  finalize: "Finaliser la facture",
  remove: "Supprimer",
  close: "Fermer",
  loading_companies: "Chargement des entreprises...",
  error_loading_companies: "Erreur lors du chargement des entreprises",
  loading_clients: "Chargement des clients...",
  error_loading_clients: "Erreur lors du chargement des clients",
  add_article: "Ajouter un article",
  custom_fields: "Ajouter des champs personnalisés",
  no_clients_for_company: "Aucun client pour cette entreprise",
  engagement_id: "Bon de commande",
  total: "Total (TTC)",
  add_field: "Ajouter un champ",
  payment_info: "Informations de paiement",
  bank_name: "Nom",
  payment_terms: "Modalités de paiement",
  note: "Note / Mentions particulières",
  label: "Label",
  value: "Valeur",

  update_invoice: "Modifier la facture",
  details_title: "Détails de la facture",
  details_personnel: "Informations fournisseur / client",
  select: "Choisir un choix",
  select_offer: "Sélectionnez une offre",
  Offre_title: "Offre:",
  other: "Autre",
  due_duration: "Durée d'échéance* ",
  no_invoices_in_this_tab: "Aucune facture dans cet onglet",
  missing_fields_description:
    "Veuillez remplir tous les champs requis avant de sauvegarder la facture.",
  invalid_ht: "Vous devez ajouter des offres à votre facture",
  description: "Description",
  product_service: "Produit/Service",
  tva_percentage: "TVA (%)",
  edit: "Modifier",
  consult: "Consulter",
  view_receipt: "Voir le reçu",
  go_to_dashboard: "Tableau de bord",
  siren: "SIREN",
  siret: "SIRET",
  client_type: "Type de client",
  vat_number: "Numéro TVA",
  phone: "Téléphone",
  rm: "Registre du commerce",

  laborCost: "Coût main-d’œuvre",
  travelExpenses: "Frais de déplacement",

  number_prefix: "N° de ",
  pending: "En attente",
  emitter: "Émetteur",
  receiver: "Destinataire",
  company: "Société",
  address: "Adresse",
  info: "Informations",
  details: "Détail",
  unit_price: "PU HT",
  vat_percent: "TVA (%)",
  discount: "Remise",
  total_ttc: "Total TTC",
  total_vat: "Total TVA",
  additional_fees: "Frais supplémentaires",
  payment_method: "Mode de règlement",
  bank_info: "Informations bancaires",
  bank: "Banque",
  iban: "IBAN",
  bic: "BIC",
  rib: "RIB",
  company_signature: "Signature de la société",
  page: "Page",
  number: "N° de ",
  quote: {
    quote: "Devis ",
  },
  credit: {
    credit_note: "Avoir",
  },
  invoice: "facture",

  no_payment_method: "Aucun mode de règlement fourni",
  no_note: "Aucune note fournie",
  total_tva: "Total TVA",
  executionConditions: "Conditions d'exécution",

  no_companies_available: "Aucune société disponible",
  total_credit: "Totale de l'avoir",
  partially_paid: "Partiellement payé",
  unpaid: "Non payé",
  paid_status: "Payé",

  draftt: "Brouillon",
  to_validate: "À valider",
  validated: "Validé",
  published: "Publié",

  column_ref: "Réf",
  column_ref_invoice: "Réf facture",
  column_client: "Client",
  column_payment_status: "Statut de paiement",
  column_total_ttc: "Total TTC",
  column_invoice_date: "Date de facturation",
  column_invoice_status: "Statut de facturation",
  column_credit_notes: "Avoirs",

  error_company_required: "Veuillez sélectionner une société.",
  error_client_required: "Veuillez sélectionner un client.",
  error_date_facturation_required: "Veuillez choisir une date de facturation.",
  error_date_echeance_required: "Veuillez choisir une date d’échéance.",
};
